import { isInstrucaoSimples } from "./examsUtils";
import api from "../../../servicos/api";

const abrirPdfDaApi = (blob) => {
  const url = window.URL.createObjectURL(blob);
  const novaJanela = window.open(url, "_blank");
  if (novaJanela) {
    setTimeout(() => {
      novaJanela.print();
    }, 1000);
  }
};

export const gerarPdfPorExames = async (exames) => {
  const examesEncontrados = [];
  const examesSemOrientacoes = [];

  exames.forEach((exame) => {
    if (isInstrucaoSimples(exame.instrucoes)) {
      examesSemOrientacoes.push(exame.nome);
      return;
    }

    examesEncontrados.push({
      id: exame.id,
      nome: exame.nome,
      material: exame.material,
      instrucoes: "Sem instruções específicas",
      entrega: exame.entrega,
    });
  });

  if (examesEncontrados.length > 0) {
    try {
      const response = await api.post(
        "v2/geral/orientacoes-pdf",
        { exames: examesEncontrados },
        { responseType: "blob" },
      );

      abrirPdfDaApi(response.data);

      return {
        sucesso: true,
        examesProcessados: examesEncontrados.map((e) => e.nome),
        examesSemOrientacoes,
        examesNaoEncontrados: [],
        totalProcessado: exames.length,
      };
    } catch (erro) {
      console.error("Erro ao gerar PDF via API:", erro);
      throw new Error("Falha ao gerar PDF. Tente novamente.");
    }
  }

  return {
    sucesso: false,
    examesProcessados: [],
    examesSemOrientacoes,
    examesNaoEncontrados: [],
    totalProcessado: exames.length,
  };
};
